export default __webpack_public_path__ + "static/media/icon-catalogo.6bd62ebe.png";